import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=c21c213e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=c21c213e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c213e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c21c213e')) {
      api.createRecord('c21c213e', component.options)
    } else {
      api.reload('c21c213e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=c21c213e&scoped=true&", function () {
      api.rerender('c21c213e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NM6SAVBYDDmI/JS/comp/DateRangeExt.vue"
export default component.exports